import { render } from "./DriverTable.vue?vue&type=template&id=6a81326e&scoped=true"
import script from "./DriverTable.vue?vue&type=script&lang=js"
export * from "./DriverTable.vue?vue&type=script&lang=js"

import "./DriverTable.vue?vue&type=style&index=0&id=6a81326e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a81326e"]])

export default __exports__